import { createZodDto } from './zod';

import { z } from 'zod';

/**
 * Strict on purpose: a client can never smuggle a confirmation, a transcript
 * or an organization into a turn. 4 000 chars ≈ 4 % of the Express body limit.
 */
export const AgentChatSchema = z.strictObject({
  conversationId: z.string().min(1).max(40).optional(),
  message: z.string().trim().min(1).max(4000),
  /** Client-generated, dedupes a retried POST (Cloudflare retry, flaky mobile). */
  clientRequestId: z.string().min(1).max(40).optional(),
});
export class AgentChatDto extends createZodDto(AgentChatSchema) {}

export const AgentDecisionSchema = z.strictObject({
  decision: z.enum(['approve', 'reject']),
});
export class AgentDecisionDto extends createZodDto(AgentDecisionSchema) {}

export const AgentConversationParamsSchema = z.strictObject({
  publicId: z.string().min(1).max(40),
});
export class AgentConversationParamsDto extends createZodDto(
  AgentConversationParamsSchema,
) {}

export const AgentDecisionParamsSchema = AgentConversationParamsSchema.extend({
  toolCallId: z.string().min(1).max(64),
}).strict();
export class AgentDecisionParamsDto extends createZodDto(
  AgentDecisionParamsSchema,
) {}

export const AgentConversationsQuerySchema = z.object({
  skip: z.coerce.number().int().min(0).default(0),
  take: z.coerce.number().int().min(1).max(100).default(20),
});
export class AgentConversationsQueryDto extends createZodDto(
  AgentConversationsQuerySchema,
) {}
